// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__27PdI","modalFooterButton":"ModalNotes_modalFooterButton__uO-4g"};